import useInitializeDatabaseAdvancedForm from './useInitializeDatabaseAdvancedForm'

export default useInitializeDatabaseAdvancedForm
